// NEW MAIN PRE-CHECKOUT JS

document.addEventListener("DOMContentLoaded", function () {

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const customerEmail_URL = params.get('customerEmail');

    params.delete('customerEmail');

    console.log('customerEmail_URL', customerEmail_URL)

    const baseUrl = window.location.href.split('?')[0];
    history.replaceState(null, '', baseUrl);

    async function doEverything() {
        const shouldExtendTimer = await fetchDataIfRequired();
        await doAllTheRest(shouldExtendTimer);
    }

  

    async function fetchDataIfRequired() {
        if (customerEmail_URL !== null) {
            localStorage.setItem("customerEmail", customerEmail_URL);
            //localStorage.setItem("itemIds", JSON.stringify(itemIds_URL));
            let customerEmail = localStorage.getItem('customerEmail');
            const url_personal_api = `https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_getQuizAnalysis/${encodeURIComponent(customerEmail)}`;


            fetch(url_personal_api, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    const quiz_answers = json.metafields;
                    if (quiz_answers && quiz_answers.length > 0) {

                        const last_quiz = quiz_answers[quiz_answers.length - 1];
                        const quiz = JSON.parse(last_quiz.value);
                        //const potential = quiz.potential;
                        //const priority = quiz.priority
                        console.log('quiz', quiz)
                        const personalInfo = quiz.personalInfo
                         const fb_gender = personalInfo.gender === 'Male' ? 'm' : 'f';
                        localStorage.setItem("gender", fb_gender);
                        const recommendation = personalInfo['recommendation']

                        let allProductData = [];
                        //let supplements = {};
            
                         setUserProps({
                            gender: personalInfo.gender,
                            age: personalInfo.age,
                            type: personalInfo.athleteType,
                            wereable_device: personalInfo.customerWearable
                         });
                    

                        fetchAllProductData().then(allProduct => {

                            allProductData = allProduct;

                            // The rest of your script that depends on allProductData
                            console.log('Ready to proceed with the rest of the script.');
                
                            //cureRecommendation(); //also_help_for population
                            createAllSupplementElement(); // reused for pre-checkout page.

                            //localStorage.setItem("currentSupplement", JSON.stringify(recommendation));
                            localStorage.setItem("currentSupplementCart", JSON.stringify(recommendation));
                            //localStorage.setItem("explanations", JSON.stringify(explanation));
                            //let initialCurrentQuantities = { ...quantities };
                            //localStorage.setItem("currentQuantities", JSON.stringify(initialCurrentQuantities));
                            //let yourBoxText = `Your ${Object.keys(priority)[0]} Box`
                            //localStorage.setItem("yourBoxText", yourBoxText);
                            

                            const supplementsStr = localStorage.getItem('currentSupplementCart');
                            //supplements = JSON.parse(supplementsStr);
                            window.currentSupplementCart= JSON.parse(supplementsStr);

                            // Setup cart watcher for pre-checkout
                        }).catch(console.error);



                        async function fetchAllProductData() {
                            const allProductData = [];
                        
                            Object.entries(fetchDataSupplement).forEach(([supplementName, dataDetails]) => {
                                const dataElement = finalDataExaminDict[supplementName];
                                //const supplementData = JSON.parse(dataElement || '{}');
                                const supplementData = dataElement
                                const tags = dataDetails.tags.split(',').map(tag => tag.trim().toLowerCase());
                                const priceIndividual = dataDetails.price;
                                const supplementDose = dataDetails.dose;
                                const supplementUnit = dataDetails.unit;
                                const variantId = dataDetails.variantId;
                                const featuredImage = dataDetails.featuredImageUrl;
                        
                                //const card = createProductCard(supplementName, supplementName, dataElement, supplementData, tags, priceIndividual, supplementDose, supplementUnit, variantId, featuredImage);
                        
                                allProductData.push({
                                    //card,
                                    tags,
                                    supplementData,
                                    priceIndividual,
                                    supplementName,
                                    supplementDose,
                                    supplementUnit
                                });
                            });
                        
                            console.log('All product data fetched:', allProductData);
                            return allProductData; // You might want to return or do something with this data
                        }



                        function createAllSupplementElement() {
                            // Step 1: Find the highest scores for each category across all products
            
                            console.log("entered CreateAllSupplementElement")
            
                            const interCategory = []
            
                            Object.keys(recommendation).forEach(supplementName => {
                                recommendation[supplementName][1].forEach(tag => {
                                    interCategory.push(tag)
                                })
                            });
            
                            let interestedCategory = [...new Set(interCategory)];
            
                            const allSupplementsList= Object.keys(fetchDataSupplement);
                            const recommendedSupplementList = Object.keys(recommendation);
            
                            let AllSupplementWithTag = {}; //This dictionary is being saved with the structure key = supplement name / value = [[list of tags], boolean comes from recommendation] and is being used in the pre-checkout page
            
                            allProductData.forEach(supp => {
                                const { supplementData, supplementName } = supp
            
                                    AllSupplementWithTag[supplementName] = [[], false]
            
                                    if (recommendedSupplementList.includes(supplementName)) {
                                        AllSupplementWithTag[supplementName][1] = true;
                                    }
            
                                    interestedCategory.forEach(subcategoryKey => {
                                        const categoryKey = getFocusArea(subcategoryKey);
                                        if (supplementData.focusAreas[categoryKey]) {
                                            if (supplementData.focusAreas[categoryKey]['layer2'][subcategoryKey]) {
                                                AllSupplementWithTag[supplementName][0].push(subcategoryKey)
                                            }
                                        }
                                    })
                                
                            })
            
                            localStorage.setItem("AllSupplementWithTags", JSON.stringify(AllSupplementWithTag));
                        }

                        function getFocusArea(subcategoryKey) {
                            // Helper function to search recursively
                            function search(currentCategory, key) {
                                for (const [subcategory, value] of Object.entries(currentCategory)) {
                                    if (subcategory === key) {
                                        return true; // Found the subcategory at the current level
                                    }
                                    // If the value is an object and not empty, recurse into it
                                    if (typeof value === 'object' && Object.keys(value).length > 0) {
                                        if (search(value, key)) {
                                            return subcategory; // Return the parent category if found in deeper levels
                                        }
                                    }
                                }
                                return false; // Not found in the current path
                            }
        
                            // Search in each top-level category
                            for (const [category, data] of Object.entries(categories)) {
                                if (search(data, subcategoryKey)) {
                                    return category; // Return the top-level category when found
                                }
                            }
        
                            return null; // Return null if the subcategory is not found
                        }


                    }
                    
                    
                })

                .catch((error) => {
                    console.error('Error fetching quiz analysis:', error);
                });
            return true;
        } else {
            return false;
        }

    }


    // Function to watch for changes in window.currentSupplementCart


    async function doAllTheRest(shouldExtendTimer) {
        console.log('shouldExtendTimer', shouldExtendTimer)
        let timerInterval; // Declare timerInterval globally

        //const supplementsStr = localStorage.getItem('currentSupplement');
        //const supplementsStr = localStorage.getItem('currentSupplementCart');
        //const supplements = JSON.parse(supplementsStr);



        const AllSupplementWithTagsStr = localStorage.getItem('AllSupplementWithTags');
        const AllSupplementWithTags = JSON.parse(AllSupplementWithTagsStr);
        console.log('AllSupplementWithTags')
        console.log(AllSupplementWithTags)

        // Remove all timer and popup discount logic - now using global cart drawer logic


        function getUniqueTags(supplementDict) {
            const uniqueTags = new Set();
        
            for (const supplement in supplementDict) {
                if (Array.isArray(supplementDict[supplement][1])) {
                    supplementDict[supplement][1].forEach(tag => uniqueTags.add(tag));
                }
            }
        
            return Array.from(uniqueTags);
        }


        const uniqueTags = getUniqueTags(window.currentSupplementCart);

        function populateTags() {
            const TagsContainer = document.querySelector('.tags-container');

            uniqueTags.forEach(tag => {
                const tagElement = document.createElement('div');
                tagElement.className = 'tag';

                // Create the span for the tag text
                const span = document.createElement('span');
                span.className = 'tag-content';
                span.classList.add('orange');
                span.textContent = tag;
                
                // Create the image
                const img = document.createElement('img');
                img.src = 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/orange-valid.png?v=1746247706';
                img.alt = 'tag icon';
                img.className = 'tag-icon';

                // Add span and img as siblings to the tag div
                tagElement.appendChild(img);
                tagElement.appendChild(span);
                

                // Append to container
                TagsContainer.appendChild(tagElement);
            });
        }

        populateTags();

        // New function to display applied discounts using global cart drawer logic
        function displayAppliedDiscounts() {
            console.log('📋 Displaying applied discounts using global logic');
            
            // Get applied discounts from localStorage (same as cart drawer)
            const appliedDiscounts = getAppliedDiscounts();
            const discountCodes = Object.keys(appliedDiscounts);
            
            // Hide all discount lines initially
            const mainDiscountLine = document.getElementById('payment-main-discount-line');
            const limitedDiscountLine = document.getElementById('payment-limited-discount-line');
            
            if (mainDiscountLine) mainDiscountLine.style.display = 'none';
            if (limitedDiscountLine) limitedDiscountLine.style.display = 'none';
            
            // Display each applied discount
            discountCodes.forEach((discountCode, index) => {
                const discount = appliedDiscounts[discountCode];
                
                // Use the first discount line for the first discount, second line for second discount
                const discountLine = index === 0 ? mainDiscountLine : limitedDiscountLine;
                const discountPriceElement = index === 0 ? 
                    document.getElementById('main-discount-price') : 
                    document.getElementById('limited-discount-price');
                const discountCodeElement = index === 0 ? 
                    document.getElementById('applied-main-discount-code') : 
                    document.getElementById('applied-limited-discount-code');
                const discountPercentageElement = index === 0 ? 
                    document.getElementById('applied-main-discount-percentage') : 
                    document.getElementById('applied-limited-discount-percentage');
                const discountRemoveBtn = index === 0 ? 
                    document.getElementById('main-discount-remove-btn') : 
                    document.getElementById('limited-discount-remove-btn');
                
                if (discountLine && discountPriceElement && discountCodeElement) {
                    // Calculate discount amount using global logic
                    const savings = calculateDiscountSavings(discount);
                    const formattedSavings = formatWithCurrency(window.Shopify?.currency, savings.toFixed(2));
                    
                    // Update elements
                    discountPriceElement.textContent = `-${formattedSavings}`;
                    discountCodeElement.textContent = discount.code;
                    
                    if (discountPercentageElement) {
                        if (discount.valueType === 'percentage') {
                            discountPercentageElement.textContent = `(-${discount.value}%)`;
                        } else {
                            discountPercentageElement.textContent = '';
                        }
                    }
                    
                    // Set data attribute for remove button
                    if (discountRemoveBtn) {
                        discountRemoveBtn.setAttribute('data-discount-code', discount.code);
                    }
                    
                    // Show the discount line
                    discountLine.style.display = 'flex';
                    discountLine.classList.remove('expired');
                }
            });
        }

    




        // Popup discount functionality removed - using global cart drawer logic

    

        // Timer countdown functionality removed - using global cart drawer logic


        updateCart();
        
        const subscriptionDetailsContainer = document.getElementById('subscription-details-content');
        const toggleDetailsButton = document.getElementById('toggle-subscription-details');
        const applicationItem = document.querySelector('.subscription-item.application');

        // Toggle subscription details visibility
        toggleDetailsButton.addEventListener('click', function () {
            console.log('clicked toggle details button')
            console.log(subscriptionDetailsContainer)
            console.log(subscriptionDetailsContainer.classList)
            subscriptionDetailsContainer.classList.toggle('expanded');
            applicationItem.classList.toggle('expanded');
            toggleDetailsButton.innerHTML = '';
            toggleDetailsButton.innerHTML = subscriptionDetailsContainer.classList.contains('expanded') 
                ? `Hide details <span><img src='https://cdn.shopify.com/s/files/1/0781/4522/4995/files/next.png?v=1738134361' class='up'></span>` 
                : `Show details <span><img src='https://cdn.shopify.com/s/files/1/0781/4522/4995/files/next.png?v=1738134361' class='down'></span>`;
        });

        async function updateCart() {
            const currentSupplementList = document.getElementById('current-supplement-list');
            const subscriptionDetailsContainer = document.getElementById('subscription-details-content');
        
        
            
            currentSupplementList.innerHTML = ''; // Clear existing content
            subscriptionDetailsContainer.innerHTML = ''; // Clear subscription details
        
            const supplementNames = Object.keys(window.currentSupplementCart).sort();
        
            document.getElementById('checkout-number-supplements').textContent = `(${supplementNames.length})`;

            supplementNames.forEach((supplementName) => {
                if (!fetchDataSupplement.hasOwnProperty(supplementName)) {
                        return; // skip this supplement
                    }
                const supplementItem = document.createElement('div');
                supplementItem.classList.add('card-supplement-item');
                supplementItem.classList.add('current-supplement-item');

                supplementItem.innerHTML = `
                        <div class="card-supplement-card">
                            <button class="remove-button" data-supplement="${supplementName}">
                                <img src="https://cdn.shopify.com/s/files/1/0781/4522/4995/files/cross.png?v=1738296862" alt="remove">
                            </button>
                
                            <div class="card-supplement-image">
                                <img src="${pills_shooting[supplementName]}" alt="${supplementName}">
                            </div>
                
                            <div class="card-supplement-info">
                                <p class="card-supplement-name current-supplement-name">${supplementName}</p>
                                <p class="card-supplement-dosage">${doses[supplementName]}${unit[supplementName]} · ${numberOfCapsules[supplementName]}</p>
                            </div>
                
                            <div class="card-supplement-bottom-row">
                                <p class="card-supplement-price current-supplement-price price convert-price" data-base-price="${priceDataBase[supplementName]}">${priceSupplements[supplementName]}</p>
                                <button class="current-more-info more-info-button" data-supplement="${supplementName}">Details</button>
                            </div>
                        </div>
                    `;
        
                currentSupplementList.appendChild(supplementItem);
        
                // Populate Subscription Details
                const subscriptionItem = document.createElement('div');
                subscriptionItem.classList.add('subscription-detail-item');
        
                subscriptionItem.innerHTML = `
                    <div class="subscription-detail-content">
                        <div class="subscription-detail-image">
                            <img src="${pills[supplementName]}" alt="${supplementName}">
                        </div>
                        <div class="subscription-detail-info">
                            <p class="subscription-detail-name">${supplementName}</p>
                            <p class="subscription-detail-dose">${doses[supplementName]} ${unit[supplementName]}</p>
                            <p class="subscription-detail-capsules">${numberOfCapsules[supplementName]}</p>
                        </div>
                    </div>
                    <div class="subscription-detail-price">
                        <p class="price subscription-detail-price-text">${priceSupplements[supplementName]}</p>
                        <button class="subscription-remove-button" data-supplement="${supplementName}"><span><img src='https://cdn.shopify.com/s/files/1/0781/4522/4995/files/trash-bin.png?v=1711075560' class='trash-bin'></span>Remove</button>
                    </div>
                `;
        
                subscriptionDetailsContainer.appendChild(subscriptionItem);

                const moreInfoButton = supplementItem.querySelector('.current-more-info');
                moreInfoButton.addEventListener('click', function () {
                    showPopup(supplementName);
                });

            });
        
            // Event listener for remove buttons in main supplement list
            document.querySelectorAll('.remove-button, .subscription-remove-button').forEach(button => {
                button.addEventListener('click', async function () {
                    const supplementName = this.getAttribute('data-supplement');
                    
                    try {
                        // Use the global function to remove supplement
                        await globalRemoveSupplementFromCart(
                            supplementName,
                            null, // buttonElement
                            "Removing...", // RemovingText
                            "Removed from Stack", // RemovedText
                            "RemoveFromCartPreCheckoutUser" // eventName
                        );                    
                        // Update the cart after removal
                        //updateCart();
                        
                    } catch (error) {
                        console.error(`Failed to remove ${supplementName} from cart:`, error);
                    }
                });
            });
        
            
        

            


            // Update prices and discounts using global logic
            await updatePrices();
            displayAppliedDiscounts();
            await createSupplementCards();
            addToCartAndEnableCheckout();
            
            /*
            if (discountHasBeenApplied) {
                applyPopupDiscountCodeAndClosePopup();
            } else {
                setTimeout(function() {
                    popup.style.display = 'flex';
                }, 4000);
            }
                */
        }
        
        



        function addPrices(price1, price2) {
            const price_1 = parseFloat(price1.replace(/[^0-9.-]+/g, ""));
            const price_2 = parseFloat(price2.replace(/[^0-9.-]+/g, ""));
            const sumPrice = price_1 + price_2;
            return `S$ ${sumPrice.toFixed(2)}`;
        }

        function addPricesBase(price1, price2) {
            const price_1 = parseFloat(price1.replace(/[^0-9.-]+/g, ""));
            const price_2 = parseFloat(price2.replace(/[^0-9.-]+/g, ""));
            const sumPrice = price_1 + price_2;
            return `${sumPrice.toFixed(2)}`;
        }


        function pricePerDay(priceString) {
            // Extract the price from the string
            const price = parseFloat(priceString.replace(/[^0-9.-]+/g, ""));
            let currencyCode = 'SGD';
            if (window.Shopify && Shopify.currency && Shopify.currency.active) {
                currencyCode = Shopify.currency.active;
            }
            let finalPrice;
            if (currencyCode === 'IDR') {
                // Multiply, divide, then round up to next 1000
                finalPrice = Math.ceil((price / 30) / 1000) * 1000;
                return finalPrice.toFixed(0);
            } else if (currencyCode === 'HKD') {
                finalPrice = Math.ceil(price / 30);
                return finalPrice.toFixed(0);
            } else {
                finalPrice = price / 30;
                return finalPrice.toFixed(2);
            }
        }

        function removeDiscount(totalPrice, discount) {
            const totalPrice_ = parseFloat(totalPrice.replace(/[^0-9.-]+/g, ""));
            const discount_ = parseFloat(discount.replace(/[^0-9.-]+/g, ""));
            const finalPrice = totalPrice_ + discount_;
            return `${finalPrice.toFixed(2)}`;
        }


        function convertPrices(currencyInfo, selector = '.convert-price') {
          if (!currencyInfo || !currencyInfo.rate || !currencyInfo.active) {
            console.warn('Currency info not found');
            return;
          }
        
          const rate = parseFloat(currencyInfo.rate);
          const currencyCode = currencyInfo.active;
        
          const currencyFormats = {
            USD: "$ {{amount}}",
            EUR: "€ {{amount}}",
            GBP: "£ {{amount}}",
            SGD: "S$ {{amount}}",
            AUD: "A$ {{amount}}",
            CAD: "C$ {{amount}}",
            JPY: "¥ {{amount}}",
            INR: "₹ {{amount}}",
            CNY: "¥ {{amount}}",
            HKD: "HK$ {{amount}}",
            MYR: "RM {{amount}}",
            IDR: "Rp {{amount}}",
            DEFAULT: "{{amount}} " + currencyCode
          };
        
          const adjustmentRates = {
            USD: 1,
            EUR: 1,
            GBP: 1,
            SGD: 1,
            AUD: 1,
            CAD: 1,
            JPY: 1,
            INR: 1,
            CNY: 1,
            HKD: 1,
            MYR: 1,
            IDR: 1.1,
            DEFAULT: 1
          };
        
          const formatTemplate = currencyFormats[currencyCode] || currencyFormats.DEFAULT;
          const adjustment = adjustmentRates[currencyCode] || adjustmentRates.DEFAULT;
        
          function formatMoney(amount, format, el) {
            if (currencyCode === 'IDR') {
              const roundedUp = Math.ceil(parseFloat(amount) / 1000) * 1000;
              const rounded = roundedUp.toFixed(0);
              return format.replace('{{amount}}', rounded);
            } else if (el.id === 'price-per-day') {
              const rounded = (Math.ceil(parseFloat(amount) * 100) / 100).toFixed(2);
              return format.replace('{{amount}}', rounded);
            } else {
              const roundedUp = Math.ceil(parseFloat(amount));
              const rounded = roundedUp.toFixed(2);
              return format.replace('{{amount}}', rounded);
            }
          }
        
          document.querySelectorAll(selector).forEach(el => {
            const basePrice = parseFloat(el.getAttribute('data-base-price'));
            if (isNaN(basePrice)) return;
            
            // Get the supplement name from data-supplement attribute
            const supplementName = el.getAttribute('data-supplement');
            let convertedPrice;
            
            // Check if there's a specific price for this supplement and currency
            if (supplementName && priceSupplementsConverted[supplementName] && priceSupplementsConverted[supplementName][currencyCode]) {
              // Use the specific price from priceSupplementsConverted dictionary
              convertedPrice = priceSupplementsConverted[supplementName][currencyCode];
            } else if (supplementName && priceSupplementsConverted[supplementName] && priceSupplementsConverted[supplementName].DEFAULT) {
              // Fallback to DEFAULT price if specific currency not found
              convertedPrice = priceSupplementsConverted[supplementName].DEFAULT;
            } else {
              // Perform conversion if no specific price is available
              convertedPrice = basePrice * rate * adjustment;
            }
            
            el.textContent = formatMoney(convertedPrice, formatTemplate, el);
          });
        }



        // Updated shipping calculation using global cart drawer logic
        function updateShippingDisplay() {
            console.log('🚚 Updating shipping display using global logic');

            // Get shipping progress using global function
            let currencyCode = 'SGD';
            if (window.Shopify?.currency?.active) {
                currencyCode = Shopify.currency.active;
            }

            const shippingProgress = globalCalculateShippingProgress(currencyCode);
            const shippingPriceElement = document.getElementById('shipping-price');
            
            if (shippingProgress.freeShippingAchieved) {
                // Free shipping achieved
                shippingPriceElement.textContent = 'Free';
            
                const notFreeShippingLine = document.getElementById('not-free-shipping-text');
                const freeShippingLine = document.getElementById('free-shipping-text');
                const notFreeShippingDiv = document.getElementById('not-free-shipping-div');
                const freeShippingDiv = document.getElementById('free-shipping-div');
                const paymentItemTotalDiv = document.getElementById('payment-item-total-div');

                if (notFreeShippingLine) notFreeShippingLine.style.display = 'none';
                if (freeShippingLine) freeShippingLine.style.display = 'flex';
                if (notFreeShippingDiv) notFreeShippingDiv.style.display = 'none';
                if (freeShippingDiv) freeShippingDiv.style.display = 'flex';
                if (paymentItemTotalDiv) paymentItemTotalDiv.classList.add('free-shipping');

                const progressBar = document.getElementById('progress-fill-width');
                if (progressBar) progressBar.style.width = '100%';

                return 0;
            } else {
                // Paid shipping
                const shippingCost = calculateShippingCost(
                    globalCalculateCartTotals().subtotalAfterDiscount, 
                    currencyCode
                );
                
                const amountLeftToFreeShipping = document.getElementById('amount-left-before-free-shipping');
                if (amountLeftToFreeShipping) {
                    amountLeftToFreeShipping.textContent = ` ${shippingProgress.amountNeededFormatted} `;
                }

                shippingPriceElement.textContent = formatWithCurrency(window.Shopify?.currency, shippingCost.toFixed(2));

                const notFreeShippingLine = document.getElementById('not-free-shipping-text');
                const freeShippingLine = document.getElementById('free-shipping-text');
                const notFreeShippingDiv = document.getElementById('not-free-shipping-div');
                const freeShippingDiv = document.getElementById('free-shipping-div');
                const paymentItemTotalDiv = document.getElementById('payment-item-total-div');

                if (notFreeShippingLine) notFreeShippingLine.style.display = 'flex';
                if (freeShippingLine) freeShippingLine.style.display = 'none';
                if (notFreeShippingDiv) notFreeShippingDiv.style.display = 'block';
                if (freeShippingDiv) freeShippingDiv.style.display = 'none';
                if (paymentItemTotalDiv) paymentItemTotalDiv.classList.remove('free-shipping');

                const progressBar = document.getElementById('progress-fill-width');
                if (progressBar) {
                    progressBar.style.width = `${shippingProgress.progressPercentage}%`;
                }

                return parseFloat(shippingCost);
            }
        }

        

        // Updated price calculation using global cart drawer logic
        async function updatePrices() {
            console.log('💰 Updating prices using global cart logic');
            
            // Calculate all totals using global function
            const cartTotals = globalCalculateCartTotals();
            
            // Update subtotal (before discounts)
            const subtotalElement = document.getElementById('subtotal-price-text');
            const boxPriceElement = document.getElementById('total-box-price-text');
            if (subtotalElement) {
                subtotalElement.textContent = formatWithCurrency(window.Shopify?.currency, cartTotals.subtotal.toFixed(2));
            }
            if (boxPriceElement) {
                boxPriceElement.textContent = formatWithCurrency(window.Shopify?.currency, cartTotals.subtotal.toFixed(2));
            }
            
            // Update subtotal after discount
            const subtotalAfterDiscountElement = document.getElementById('subtotal-price-after-discount-text');
            if (subtotalAfterDiscountElement) {
                subtotalAfterDiscountElement.textContent = formatWithCurrency(window.Shopify?.currency, cartTotals.subtotalAfterDiscount.toFixed(2));
            }
            
            // Update shipping display using global logic
            updateShippingDisplay();
            
            // Update final total
            const finalTotalElement = document.getElementById('subtotal-after-discount');
            const checkoutTotalElement = document.getElementById('checkout-total-price');
            if (finalTotalElement) {
                finalTotalElement.textContent = formatWithCurrency(window.Shopify?.currency, cartTotals.finalTotal.toFixed(2));
            }
            if (checkoutTotalElement) {
                checkoutTotalElement.textContent = formatWithCurrency(window.Shopify?.currency, cartTotals.finalTotal.toFixed(2));
            }
            
            // Update daily price
            const dailyPrice = cartTotals.finalTotal / 30;
            const dailyPriceElement = document.getElementById('price-per-day');
            if (dailyPriceElement) {
                dailyPriceElement.textContent = formatWithCurrency(window.Shopify?.currency, dailyPrice.toFixed(2));
            }
            
            // Update supplement count
            const supplementCount = Object.keys(window.currentSupplementCart || {}).length;
            const supplementCountElement = document.getElementById('checkout-number-supplements');
            if (supplementCountElement) {
                supplementCountElement.textContent = `(${supplementCount})`;
            }
            
            // Execute price conversion if Shopify currency is available
            if (window.Shopify?.currency) {
                convertPrices(Shopify.currency);
            }
            
            console.log('✅ Prices updated using global logic');
        }




        async function addToCartAndEnableCheckout() {
            const checkoutButton = document.querySelector('.hero-cta-button');
            checkoutButton.disabled = true;

            const ipAddress = sessionStorage.getItem('ipAddress');
            const timestamp = Date.now();

            try {
                // Get current cart contents
                const cartResponse = await fetch('/cart.js');
                if (!cartResponse.ok) {
                    throw new Error(`HTTP error! status: ${cartResponse.status}`);
                }
                const currentCart = await cartResponse.json();
                console.log('Current cart:', currentCart);

                // Get current supplement cart from window
                const currentSupplementCart = window.currentSupplementCart || {};
                console.log('Current supplement cart:', currentSupplementCart);

                // Create sets for comparison
                const cartSupplementNames = new Set();
                const supplementCartNames = new Set();

                // Extract supplement names from current cart
                currentCart.items.forEach(item => {
                    // Find supplement name by variant ID
                    const supplementName = Object.keys(fetchDataSupplement).find(name => 
                        fetchDataSupplement[name].variantId === item.variant_id.toString()
                    );
                    if (supplementName) {
                        cartSupplementNames.add(supplementName);
                    }
                });

                // Extract supplement names from currentSupplementCart
                Object.keys(currentSupplementCart).forEach(supplementName => {
                    supplementCartNames.add(supplementName);
                });

                console.log('Cart supplements:', Array.from(cartSupplementNames));
                console.log('Supplement cart supplements:', Array.from(supplementCartNames));

                // Remove items that are in cart but not in currentSupplementCart
                const supplementsToRemove = Array.from(cartSupplementNames).filter(name => 
                    !supplementCartNames.has(name)
                );

                console.log('Supplements to remove:', supplementsToRemove);

                // Remove supplements from cart using the global function
                for (const supplementName of supplementsToRemove) {
                    try {
                        await globalRemoveSupplementFromCart(
                            supplementName,
                            null, // buttonElement
                            "Removing...", // RemovingText (not used)
                            "Removed from Stack", // RemovedText (not used)
                            "RemoveFromCartPreCheckoutSync" // eventName
                        );
                        console.log(`Removed ${supplementName} from cart`);
                    } catch (error) {
                        console.error(`Failed to remove ${supplementName} from cart:`, error);
                        fbq('trackCustom', 'errorFetchRemoveFromCart', {
                            ip_address: ipAddress,
                            timestamp: timestamp,
                            error: error,
                            supplement_name: supplementName
                        });
                    }
                }

                // Add items that are in currentSupplementCart but not in cart
                const supplementsToAdd = Array.from(supplementCartNames).filter(name => 
                    !cartSupplementNames.has(name)
                );

                console.log('Supplements to add:', supplementsToAdd);

                // Add supplements to cart using the global function
                for (const supplementName of supplementsToAdd) {
                    try {
                        await globalAddSupplementToCart(
                            supplementName,
                            null, // buttonElement
                            "Adding...", // AddingText (not used)
                            "Added to Stack", // AddedText (not used)
                            "AddToCartPreCheckoutSync", // eventName
                            false // shouldOpenCart
                        );
                        console.log(`Added ${supplementName} to cart`);
                    } catch (error) {
                        console.error(`Failed to add ${supplementName} to cart:`, error);
                        fbq('trackCustom', 'errorFetchAddToCart', {
                            ip_address: ipAddress,
                            timestamp: timestamp,
                            error: error,
                            supplement_name: supplementName
                        });
                    }
                }

                console.log('Cart sync completed successfully');

            } catch (error) {
                console.error('Failed to sync cart:', error);
                fbq('trackCustom', 'errorFetchAddToCart', {
                    ip_address: ipAddress,
                    timestamp: timestamp,
                    error: error
                });
            } finally {
                // Re-enable the checkout button
                checkoutButton.disabled = false;
          
            }

            // window.location.href = '/checkout?discount=';
        }
        

        async function createSupplementCards() {
        
            const availableSupplementList = document.getElementById('available-supplement-list');
            availableSupplementList.innerHTML = ""; // Clear existing content

            const track = document.getElementById("available-supplement-list");
            const dotsContainer = document.getElementById("carousel-dots");
            const prevBtn = document.getElementById("carousel-prev");
            const nextBtn = document.getElementById("carousel-next");

            const getItemsPerPage = () => {
                const windowWidth = window.innerWidth;
                if (windowWidth > 1200) return 3;
                if (windowWidth > 768) return 4;
                if (windowWidth > 600) return 3;
                return 2;
            };

            let numberOfItems = 0;
            
            // Process supplements
            for (const [supplementName, details] of Object.entries(fetchDataSupplement)) {
                if (window.currentSupplementCart.hasOwnProperty(supplementName)) continue;
        
                const supplementItem = document.createElement('div');
                supplementItem.classList.add('available-supplement-item');

                supplementItem.innerHTML = `
                    <div class="available-supplement-card">
                        <button class="available-more-info more-info-button" data-supplement="${supplementName}">
                            <img src="https://cdn.shopify.com/s/files/1/0781/4522/4995/files/info-icon.png?v=1745561702" alt="info">
                        </button>
            
                        <div class="card-supplement-image">
                            <img src="${pills_shooting[supplementName]}" alt="${supplementName}">
                        </div>
            
                        <div class="card-supplement-info">
                            <p class="card-supplement-name">${supplementName}</p>
                            <p class="card-supplement-dosage">${doses[supplementName]}${unit[supplementName]} · ${numberOfCapsules[supplementName]}</p>
                        </div>
            
                        <div class="card-supplement-bottom-row">
                            <p class="card-supplement-price price convert-price" data-base-price="${priceDataBase[supplementName]}" data-supplement="${supplementName}">${priceSupplements[supplementName]}</p>
                            <button class="add-button" data-supplement="${supplementName}">+ Add</button>
                        </div>
                    </div>
                `;
        
                availableSupplementList.appendChild(supplementItem);
                numberOfItems++;
        
                // Add event listener to the add button
                const addButton = supplementItem.querySelector('.add-button');
                addButton.addEventListener('click', () => globalAddSupplementToCart(supplementName, null, "Adding...", "Added to Stack", "AddToCartPreCheckoutUser", false));

                const moreInfoButton = supplementItem.querySelector('.available-more-info');
                moreInfoButton.addEventListener('click', function () {
                    console.log('inside show popup available stuff')
                    console.log(supplementName)
                    showPopup(supplementName);
                });
            }

            const totalPages = Math.ceil(numberOfItems / getItemsPerPage());

            // Calculate initial index based on scroll position
            const calculateCurrentIndex = () => {
                const cssText = track.style.cssText;
               
                const match = cssText.match(/translateX\((-?\d+)(%)\)/);
               
                if (match) {
                    const percent = parseFloat(match[1]);
                    let computedIndex = Math.round(Math.abs(percent / 100));
               
                    // Clamp if index is out of range
                    if (computedIndex >= totalPages) {
                        computedIndex = computedIndex-1;
                        return [true, computedIndex];
                    }
               
                    return [false, computedIndex];
                }
               
                return [false, 0];
            };

            // Set initial index based on current scroll position
            const currentIndexComputation = calculateCurrentIndex();
            let currentIndex = currentIndexComputation[1];

            const updateInitialDots = () => {
                dotsContainer.innerHTML = '';
                for (let i = 0; i < totalPages; i++) {
                    const dot = document.createElement("button");
                    if (i === currentIndex) dot.classList.add("active");
                    dotsContainer.appendChild(dot);
                }
            };

            // Initial creation of dots
            updateInitialDots();

            const updateCarousel = () => {
                const offset = -(currentIndex * 100);
                track.style.transform = `translateX(${offset}%)`;
            
                [...dotsContainer.children].forEach((dot, i) => {
                    dot.classList.toggle("active", i === currentIndex);
                });
            };

            if(currentIndexComputation[0]){
                updateCarousel();
            }
            
            // Add scroll event listener to update index
            track.addEventListener('scroll', () => {
                const newIndex = calculateCurrentIndex()[1];
                if (newIndex !== currentIndex) {
                    currentIndex = newIndex;
                    updateCarousel();
                }
            });
            
            prevBtn.addEventListener("click", () => {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateCarousel();
                }
            });
            
            nextBtn.addEventListener("click", () => {
                if (currentIndex < totalPages - 1) {
                    currentIndex++;
                    updateCarousel();
                }
            });
            
            // Optional: click dot to navigate
            [...dotsContainer.children].forEach((dot, index) => {
                dot.addEventListener("click", () => {
                    currentIndex = index;
                    updateCarousel();
                });
            });

            // Add window resize listener to update carousel when needed
            window.addEventListener('resize', () => {
                const newTotalPages = Math.ceil(numberOfItems / getItemsPerPage());
                if (newTotalPages !== totalPages) {
                    // If the number of pages has changed, we need to update the dots and possibly adjust the current index
                    currentIndex = Math.min(currentIndex, newTotalPages - 1);
                    updateInitialDots();
                    updateCarousel();
                }
            });
        }
        
        // Function to ensure uniform widths for available supplements
        function ensureUniformWidths(className) {
            const elements = document.querySelectorAll(className);
            let maxWidth = 0;
            elements.forEach(el => maxWidth = Math.max(maxWidth, el.offsetWidth));
            elements.forEach(el => el.style.setProperty('width', `${maxWidth}px`, 'important'));
        }
        


        function showPopup(supplementName) {
            const popupOverlay = document.getElementById(`popup-overlay-${supplementName.replace(/[ &]/g, '-')}`);
            popupOverlay.style.display = 'flex';
            document.body.classList.add('no-scroll');
        }
        
        function closePopup(supplementName) {
            const popupOverlay = document.getElementById(`popup-overlay-${supplementName.replace(/[ &]/g, '-')}`);
            popupOverlay.style.display = 'none';
            document.body.classList.remove('no-scroll');
        }
        
        // Example usage: Create popups for each supplement
        Object.keys(fetchDataSupplement).forEach(supplementName => {
            const popup = createPopup(supplementName );
        
            // // Close popup when close button is clicked
            const closeButton = popup.querySelector('.popup-info-close-button');
            closeButton.addEventListener('click', () => closePopup(supplementName));
        
            // Close popup when clicking outside of the popup content
            popup.addEventListener('click', (event) => {
                if (event.target === popup) {
                    closePopup(supplementName);
                }
            });
        });




        function findPaths(elements) {
            const result = {};

            // Helper function to search recursively and build the path
            function search(currentCategory, path) {
                for (const [key, value] of Object.entries(currentCategory)) {
                    // Construct a new path for this level
                    const newPath = path ? { ...path } : {};

                    // If this key is one of the elements, add it to the result
                    if (elements.includes(key) && !newPath[key]) {
                        newPath[key] = {};
                        buildResult(newPath, result);
                    }

                    // If value is an object, recurse into it
                    if (typeof value === 'object' && Object.keys(value).length > 0) {
                        search(value, { ...newPath, [key]: {} });
                    }
                }
            }

            // Function to merge the paths into the final result
            function buildResult(newPath, finalResult) {
                let currentLevel = finalResult;
                for (const [key, value] of Object.entries(newPath)) {
                    if (!currentLevel[key]) {
                        currentLevel[key] = {};
                    }
                    currentLevel = currentLevel[key];
                }
            }

            // Start searching
            search(categories, null);
            return result;
        }



        function createGaugeDose({
            avgCompetitorDose,
            yourDose,
            lowerLimit,
            upperLimit,
            minValue,
            maxValue,
            unit,
        }) {
            // Calculate numeric positions in percent (0–100)
            const calculatePositionNumber = (value) =>
            ((value - minValue) / (maxValue - minValue)) * 100;
        
            // Calculate positions as strings with %
            const calculatePosition = (value) =>
            `${Math.round(calculatePositionNumber(value))}%`;
        
            const calculateWidth = (upper, lower) =>
            `${Math.round(
                ((upper - lower) / (maxValue - minValue)) * 100
            )}%`;
        
            // Convert avgCompetitorDose / yourDose to numeric "left" positions
            let competitorPosition = calculatePositionNumber(avgCompetitorDose);
            let yourPosNum = calculatePositionNumber(yourDose);
        
            // Threshold to check proximity (in percentage points)
            const PROXIMITY_THRESHOLD = 3;
            let competitorOffset = 0;
            let yourOffset = 0;
        
            // Adjust positions if too close
            if (
            Math.abs(competitorPosition - yourPosNum) < PROXIMITY_THRESHOLD &&
            avgCompetitorDose !== yourDose
            ) {
            if (competitorPosition < yourPosNum) {
                competitorOffset = -1; // Shift competitor left
                yourOffset = 1; // Shift your dose right
            } else {
                competitorOffset = 1; // Shift competitor right
                yourOffset = -1; // Shift your dose left
            }
            }
        
            // Apply offsets to the numeric positions
            const competitorMarkerLeft = `${Math.max(
            0,
            Math.min(100, competitorPosition + competitorOffset)
            )}%`;
            const yourMarkerLeft = `${Math.max(
            0,
            Math.min(100, yourPosNum + yourOffset)
            )}%`;
        
            // Return an HTML string
            return `
            <div class="gauge-container">
                <div class="bar">
                
                <!-- Green range in the bar -->
                <div class="green-bar"
                    style="
                    left: ${calculatePosition(lowerLimit)};
                    width: ${calculateWidth(upperLimit, lowerLimit)};
                    "
                ></div>
        
                <!-- Competitor marker -->
                ${
                    avgCompetitorDose !== yourDose
                    ? `
                        <div class="marker" style="left: ${competitorMarkerLeft};">
                        <!-- Thin line from marker down to bar -->
                        <div class="marker-line"></div>
                        <div class="marker-label">Average competitor<br>dose</div>
                        <div class="marker-text">▼</div>
                        </div>
                    `
                    : ""
                }
        
                <!-- Your dose marker -->
                <div class="marker your-dose" style="left: ${yourMarkerLeft};">
                    <div class="marker-line your-dose"></div>
                    <div class="marker-label your-dose">Your dose</div>
                    <div class="marker-text your-dose">▼</div>
                </div>
        
                </div> <!-- .bar -->
        
                <!-- Bottom labels -->
                <div class="labels">
                ${
                    avgCompetitorDose !== yourDose
                    ? `
                        <div class="label" style="left: ${competitorMarkerLeft};">
                        ${avgCompetitorDose}${unit}
                        </div>
                    `
                    : ""
                }
                <div class="label your-dose" style="left: ${yourMarkerLeft};">
                    ${yourDose}${unit}
                </div>
                </div> <!-- .labels -->
            </div> <!-- .gauge-container -->
            `;
        }


        function populateSupplementFact(supplementName, supplementFactsContainer) {
        
            if (!supplementFactsContainer) {
            console.error("The supplement-facts-container div is missing.");
            return;
            }
        
            // Clear existing content
            supplementFactsContainer.innerHTML = "";
        

            const squaredDiv = document.createElement('div');
            squaredDiv.className = 'squared-div';
            supplementFactsContainer.appendChild(squaredDiv);

            // Create the header section
            const header = document.createElement("div");
            header.className = "supplement-facts-header";
        
        
        
            const headerTitle = document.createElement("div");
            headerTitle.className = "header-title";
            headerTitle.textContent = "Supplement Facts";
        
            header.appendChild(headerTitle);
        
            // Add header to the container
        
            // Add serving details
            const servingSize = document.createElement("div");
            servingSize.className = "serving-size";
            servingSize.textContent = `Serving size: ${pillCounts[supplementName]}`;

            const servingPerBox = document.createElement("div");
            servingPerBox.className = "serving-per-box";
            servingPerBox.textContent = `Serving per box: 30`;
            
        
            header.appendChild(servingSize);
            header.appendChild(servingPerBox);

            const AmountPerServing = document.createElement("div");
            AmountPerServing.className = "amount-per-serving";
            AmountPerServing.textContent = `Amount Per Serving`;
            header.appendChild(AmountPerServing);

            const factDivider = document.createElement("div");
            factDivider.className = "fact-divider";
            

            squaredDiv.appendChild(header);
            squaredDiv.appendChild(factDivider);
        
            // Add ingredients section
            const ingredientsSection = document.createElement("div");
            ingredientsSection.className = "ingredients-section";
        
            supplementFact[supplementName].ingredients.forEach((ingredient) => {
            const ingredientRow = document.createElement("div");
            ingredientRow.className = "ingredient-row";
        
            const ingredientInfo = document.createElement("div");
            ingredientInfo.className = "ingredient-info";
        
            const ingredientTitle = document.createElement("div");
            ingredientTitle.className = "ingredient-title";
            ingredientTitle.textContent = ingredient.ingredient_title;
        
            ingredientInfo.appendChild(ingredientTitle);
        
            if (ingredient.ingredient_subtitle) {
                const ingredientSubtitle = document.createElement("div");
                ingredientSubtitle.className = "ingredient-subtitle";
                ingredientSubtitle.textContent = ingredient.ingredient_subtitle;
                ingredientInfo.appendChild(ingredientSubtitle);
            }
        
            if (ingredient.ingredient_subtitle_2) {
                const ingredientSubtitle2 = document.createElement("div");
                ingredientSubtitle2.className = "ingredient-subtitle";
                ingredientSubtitle2.textContent = ingredient.ingredient_subtitle_2;
                ingredientInfo.appendChild(ingredientSubtitle2);
            }
        
            if (ingredient.ingredient_subtitle_3) {
                const ingredientSubtitle3 = document.createElement("div");
                ingredientSubtitle3.className = "ingredient-subtitle";
                ingredientSubtitle3.textContent = ingredient.ingredient_subtitle_3;
                ingredientInfo.appendChild(ingredientSubtitle3);
            }
        
            const ingredientAmount = document.createElement("div");
            ingredientAmount.className = "ingredient-amount";
            ingredientAmount.textContent = ingredient.amount_per_serving;
        
            if (ingredient.amount_per_serving_subtitle) {
                const amountSubtitle = document.createElement("div");
                amountSubtitle.className = "ingredient-subtitle-amount";
                amountSubtitle.textContent = ingredient.amount_per_serving_subtitle;
                ingredientAmount.appendChild(amountSubtitle);
            }
        
            if (ingredient.amount_per_serving_subtitle_2) {
                const amountSubtitle2 = document.createElement("div");
                amountSubtitle2.className = "ingredient-subtitle-amount";
                amountSubtitle2.textContent = ingredient.amount_per_serving_subtitle_2;
                ingredientAmount.appendChild(amountSubtitle2);
            }
        
            if (ingredient.amount_per_serving_subtitle_3) {
                const amountSubtitle3 = document.createElement("div");
                amountSubtitle3.className = "ingredient-subtitle-amount";
                amountSubtitle3.textContent = ingredient.amount_per_serving_subtitle_3;
                ingredientAmount.appendChild(amountSubtitle3);
            }
        
            ingredientRow.appendChild(ingredientInfo);
            ingredientRow.appendChild(ingredientAmount);
        
            ingredientsSection.appendChild(ingredientRow);
            });
        
            squaredDiv.appendChild(ingredientsSection);
            supplementFactsContainer.appendChild(squaredDiv);
        
            // Add other details
            const otherDetails = document.createElement("div");
            otherDetails.className = "other-details";
        
            const otherIngredients = document.createElement("div");
            otherIngredients.className = "other-ingredients";
            otherIngredients.innerHTML = `<span class="supplement-facts-subtitle">Other Ingredients:</span><br> ${supplementFact[supplementName].other_ingredients}`;
        
            const dietaryRestrictions = document.createElement("div");
            dietaryRestrictions.className = "dietary-restrictions";
            dietaryRestrictions.innerHTML = `<span class="supplement-facts-subtitle">Dietary restrictions & Allergens:</span><br>${supplementFact[supplementName].dietary_restrictions}`;
        
            otherDetails.appendChild(otherIngredients);
            otherDetails.appendChild(dietaryRestrictions);
        
            if (supplementFact[supplementName].contains) {
            const contains = document.createElement("div");
            contains.className = "contains";
            contains.innerHTML = `<span class="supplement-facts-subtitle">Contains &lt;2% of:</span><br> ${supplementFact[supplementName].contains}`;
            otherDetails.appendChild(contains);
            }
        
            if (supplementFact[supplementName].contains_short) {
            const containsShort = document.createElement("div");
            containsShort.className = "contains-short";
            containsShort.innerHTML = `<span class="supplement-facts-subtitle">Contains:</span><br>  ${supplementFact[supplementName].contains_short}`;
            otherDetails.appendChild(containsShort);
            }
        
            supplementFactsContainer.appendChild(otherDetails);
        }





        function createPopup(supplementName) {
            // Create the overlay
            const overlay = document.createElement('div');
            overlay.id = `popup-overlay-${supplementName.replace(/[ &]/g, '-')}`;
            overlay.className = 'popup-overlay-add-to-box';

            // Create the popup content container
            const popupContent = document.createElement('div');
            popupContent.className = 'popup-info-content-add-to-box';

            // Create the sticky header
            const stickyHeader = document.createElement('div');
            stickyHeader.className = 'popup-info-sticky-header';

            const headerIcon = document.createElement('div');
            headerIcon.className = 'popup-info-close-button';
            headerIcon.id = 'popup-info-close-button';
            const arrowIcon = document.createElement('img');
            arrowIcon.className = 'popup-info-arrow-icon';
            arrowIcon.src = 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/arrow-navigation.png?v=1738632478';
            arrowIcon.alt = 'Back Arrow';
            headerIcon.appendChild(arrowIcon);

            const headerTitle = document.createElement('div');
            headerTitle.className = 'popup-info-header-title';
            const title = document.createElement('h2');
            title.textContent = supplementName;
            headerTitle.appendChild(title);

            stickyHeader.appendChild(headerIcon);
            stickyHeader.appendChild(headerTitle);

            // Create the info cards container
            const infoCards = document.createElement('div');
            infoCards.className = 'popup-info-cards';

            // Create the first info card
            const infoCard = document.createElement('div');
            infoCard.className = 'popup-info-card';

            const cardContent = document.createElement('div');
            cardContent.className = 'popup-info-card-content';

            const topPart = document.createElement('div');
            topPart.className = 'popup-info-top-part';

            const imageContainer = document.createElement('div');
            imageContainer.className = 'popup-info-image-container';
            const cardImage = document.createElement('img');
            cardImage.className = 'popup-info-card-image';
            cardImage.src = pillsNumberOfPills[supplementName];
            cardImage.alt = 'Supplement Image';
            imageContainer.appendChild(cardImage);

            const cardDetails = document.createElement('div');
            cardDetails.className = 'popup-info-card-details';

            const supplementInfo = document.createElement('div');
            supplementInfo.className = 'popup-info-supplement-info';
            const dose = document.createElement('p');
            dose.className = 'popup-info-dose';
            dose.textContent = `${doses[supplementName]} ${unit[supplementName]}`; // Adjust dynamically if needed
            const capsules = document.createElement('p');
            capsules.className = 'popup-info-capsules';
            capsules.textContent = `${numberOfCapsules[supplementName]}`; // Adjust dynamically if needed
            supplementInfo.appendChild(dose);
            supplementInfo.appendChild(capsules);

            const recommendations = document.createElement('div');
            recommendations.className = 'popup-info-recommendations';
            const recommendTitle = document.createElement('p');
            recommendTitle.className = 'popup-info-recommend-title';
            recommendTitle.textContent = 'Recommendations:';
            const recommendItem1 = document.createElement('div');
            recommendItem1.className = 'popup-info-recommend-item';
            const clockIcon = document.createElement('img');
            clockIcon.className = 'popup-info-icon popup-info-clock-icon';
            clockIcon.src = 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/clock_icon_85c2e11f-f411-49fc-af22-74ff95b333ab.png?v=1738715961';
            recommendItem1.appendChild(clockIcon);
            const recommendText1 = document.createElement('p');
            recommendText1.textContent = supplementIntakeGuidelines[supplementName].time;
            recommendItem1.appendChild(recommendText1);

            const recommendItem2 = document.createElement('div');
            recommendItem2.className = 'popup-info-recommend-item';
            const foodIcon = document.createElement('img');
            foodIcon.className = 'popup-info-food-icon';
            foodIcon.src = 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/food_icon_3cb4d3c3-cc0d-48dd-bf74-e391364ddca5.png?v=1738715961';
            foodIcon.alt = 'Food';
            recommendItem2.appendChild(foodIcon);
            const recommendText2 = document.createElement('p');
            recommendText2.textContent = supplementIntakeGuidelines[supplementName].food;
            recommendItem2.appendChild(recommendText2);

            recommendations.appendChild(recommendTitle);
            recommendations.appendChild(recommendItem1);
            recommendations.appendChild(recommendItem2);

            cardDetails.appendChild(supplementInfo);
            cardDetails.appendChild(recommendations);

            topPart.appendChild(imageContainer);
            topPart.appendChild(cardDetails);

            const tags = document.createElement('div');
            tags.className = 'popup-info-tags';
            const tagNames = supplementToGoalsL1L2_very_short[supplementName];
            tagNames.forEach(tagName => {
                const tag = document.createElement('span');
                tag.className = 'popup-info-tag';
                tag.textContent = tagName;
                tags.appendChild(tag);
            });

            cardContent.appendChild(topPart);
            cardContent.appendChild(tags);

            infoCard.appendChild(cardContent);
            infoCards.appendChild(infoCard);

            // Create the description card using innerHTML
            const descriptionCard = document.createElement('div');
            descriptionCard.className = 'popup-info-card description-card';
            descriptionCard.innerHTML = `
                    <div class="popup-info-icon-description">
                        <div class="popup-info-icon-container">
                            <img class="popup-info-icon-img" src="https://cdn.shopify.com/s/files/1/0781/4522/4995/files/info_icon_60c35118-6806-4f6b-bdfc-f6f5e071ab61.png?v=1738726898" alt="Info Icon">
                        </div>
                        <div class="popup-info-about-text">About ${supplementName}</div>
                    </div>
                    
                
                    <div class="popup-info-description-title-section">
                        <div class="popup-info-description-title-text">${supplementDescriptions[supplementName].title}</div>
                    </div>
                    <div class="popup-info-description-content">
                        <div class="popup-info-description-content-text">${supplementDescriptions[supplementName].description}</div>
                    </div>
                
            `;

            // Append the description card to the popup content
            infoCards.appendChild(descriptionCard);


            // Create the gauge card
            const gaugeCard = document.createElement('div');
            gaugeCard.className = 'popup-info-card gauge-card';
            gaugeCard.innerHTML = `
                    <div class="popup-info-icon-description">
                        <div class="popup-info-icon-container">
                            <img class="popup-info-icon-img" src="https://cdn.shopify.com/s/files/1/0781/4522/4995/files/dose_icon_13d3e4e9-53c8-451c-bec6-7d7162f84c7f.png?v=1738726947" alt="Dose Icon">
                        </div>
                        <div class="popup-info-about-text">Your dose</div>
                    </div>
                    
                
                    <div class="popup-info-gauge-container" id="gauge-dose-container">
                    </div>
                
            `;

            const gaugeContainer = gaugeCard.querySelector(".popup-info-gauge-container");
            gaugeContainer.innerHTML = ""; // Clear previous gauge if any
        
            const gaugeData = {
            avgCompetitorDose: gaugeBarDoses[supplementName].avg_competitor_dose, // Example values; adjust dynamically
            yourDose: gaugeBarDoses[supplementName].your_dose,
            lowerLimit: gaugeBarDoses[supplementName].lowerLimit,
            upperLimit: gaugeBarDoses[supplementName].upperLimit,
            minValue: gaugeBarDoses[supplementName].minValue,
            maxValue: gaugeBarDoses[supplementName].maxValue,
            unit: gaugeBarDoses[supplementName].unit,
            };
                    
            const gaugeHTML = createGaugeDose(gaugeData);
            gaugeContainer.innerHTML = gaugeHTML;

            infoCards.appendChild(gaugeCard);


            // Create the supplement facts card
            const supplementFactsCard = document.createElement('div');
            supplementFactsCard.className = 'popup-info-card supplement-facts-card';
            supplementFactsCard.innerHTML = `
                    <div class="popup-info-icon-description">
                        <div class="popup-info-icon-container">
                            <img class="popup-info-icon-img" src="https://cdn.shopify.com/s/files/1/0781/4522/4995/files/info_icon_60c35118-6806-4f6b-bdfc-f6f5e071ab61.png?v=1738726898" alt="Info Icon">
                        </div>
                        <div class="popup-info-about-text">Supplement Facts</div>
                    </div>
                    
                
                    <div class="popup-info-supplement-facts-container" id="supplement-facts-container">
                    </div>
                
            `;

            const supplementFactsContainer = supplementFactsCard.querySelector(".popup-info-supplement-facts-container");
            populateSupplementFact(supplementName, supplementFactsContainer);
        
            infoCards.appendChild(supplementFactsCard);

            // Append all sections to the popup content
            popupContent.appendChild(stickyHeader);
            popupContent.appendChild(infoCards);

            // Append the popup content to the overlay
            overlay.appendChild(popupContent);

            // Append the overlay to the body
            document.body.appendChild(overlay);

            return overlay;
        }
        
        


        function setupPreCheckoutCartWatcher() {
            console.log('🎯 Setting up pre-checkout cart watcher...');
            
            // Listen for custom cart change events
            window.addEventListener('cartChanged', function(e) {
                console.log('📢 Cart change event received by pre-checkout', e.detail);
                
                // Check if the event comes from pre-checkout
                const isFromPreCheckout = e.detail && e.detail.eventName && 
                    e.detail.eventName.toLowerCase().includes('precheckout');
                
                if (isFromPreCheckout) {
                    console.log('🔄 Event from pre-checkout - updating cart immediately');
                    
                    // Get the updated cart from localStorage
                    try {
                        const cartData = localStorage.getItem('currentSupplementCart');
                        if (cartData) {
                            window.currentSupplementCart = JSON.parse(cartData);
                            updateCart();
                            // Also update prices and discounts
                            //updatePrices();
                            //displayAppliedDiscounts();
                        }
                    } catch (error) {
                        console.error('Error parsing cart data:', error);
                    }
                } else {
                    console.log('⏳ Event from outside pre-checkout - waiting for delayed event');
                }
            });
            
            // Listen for delayed cart change events (for non-pre-checkout changes)
            window.addEventListener('cartChangedDelayed', function(e) {
                console.log('📢 Delayed cart change event received by pre-checkout', e.detail);
                
                // Check if the event comes from pre-checkout (skip if it does)
                const isFromPreCheckout = e.detail && e.detail.eventName && 
                    e.detail.eventName.toLowerCase().includes('precheckout');
                
                if (!isFromPreCheckout) {
                    console.log('🔄 Delayed event from outside pre-checkout - updating cart now');
                    
                    // Get the updated cart from localStorage
                    try {
                        const cartData = localStorage.getItem('currentSupplementCart');
                        if (cartData) {
                            window.currentSupplementCart = JSON.parse(cartData);
                            updateCart();
                            // Also update prices and discounts
                            //updatePrices();
                            //displayAppliedDiscounts();
                        }
                    } catch (error) {
                        console.error('Error parsing cart data:', error);
                    }
                } else {
                    console.log('⏭️ Delayed event from pre-checkout - already handled immediately');
                }
            });
            
            // Watch for localStorage changes (from other tabs/windows)
            window.addEventListener('storage', function(e) {
                if (e.key === 'currentSupplementCart') {
                    console.log('📢 Storage change detected by pre-checkout');
                    try {
                        window.currentSupplementCart = JSON.parse(e.newValue);
                        updateCart();
                        // Also update prices and discounts
                        updatePrices();
                        displayAppliedDiscounts();
                    } catch (error) {
                        console.error('Error parsing cart data from storage:', error);
                    }
                }
            });
            
            console.log('✅ Pre-checkout cart watcher initialized');
        }

        // Function to setup discount management (add/remove)
        function setupDiscountManagement() {
            console.log('🎫 Setting up discount management for pre-checkout...');
            
            // Event handlers for discount removal
            function handleDiscountRemoval(event) {
                const discountCode = event.currentTarget.getAttribute('data-discount-code');
                if (!discountCode) return;
                
                console.log(`🗑️ Removing discount: ${discountCode}`);
                
                // Use global function to remove discount
                globalRemoveAppliedDiscount(discountCode).then(result => {
                    if (result.success) {
                        console.log(`✅ Discount ${discountCode} removed successfully`);
                        // Update display
                        displayAppliedDiscounts();
                        updatePrices();
                    } else {
                        console.error(`❌ Failed to remove discount ${discountCode}:`, result.message);
                    }
                });
            }
            
            // Event handler for discount application
            function handleDiscountApplication() {
                const discountInput = document.getElementById('pre-checkout-discount-input');
                const applyButton = document.getElementById('pre-checkout-apply-discount-btn');
                const messageElement = document.getElementById('pre-checkout-discount-message');
                
                if (!discountInput || !applyButton) return;
                
                const discountCode = discountInput.value.trim();
                if (!discountCode) {
                    showDiscountMessage('Please enter a discount code', 'error');
                    return;
                }
                
                console.log(`🎫 Applying discount: ${discountCode}`);
                
                // Use global function to apply discount
                globalAddDiscount(
                    discountCode,
                    applyButton,
                    'Checking...',
                    'Applied',
                    'Invalid',
                    'Already Applied'
                ).then(result => {
                    if (result.success) {
                        console.log(`✅ Discount ${discountCode} applied successfully`);
                        // Clear input and update display
                        discountInput.value = '';
                        displayAppliedDiscounts();
                        updatePrices();
                        showDiscountMessage('Discount applied successfully!', 'success');
                    } else {
                        console.error(`❌ Failed to apply discount ${discountCode}:`, result.message);
                        showDiscountMessage(result.message || 'Failed to apply discount', 'error');
                    }
                });
            }
            
            // Helper function to show discount messages
            function showDiscountMessage(message, type) {
                const messageElement = document.getElementById('pre-checkout-discount-message');
                if (!messageElement) return;
                
                messageElement.textContent = message;
                messageElement.className = `discount-input-message ${type}`;
                messageElement.style.display = 'block';
                
                // Hide message after 3 seconds
                setTimeout(() => {
                    messageElement.style.display = 'none';
                }, 3000);
            }
            
            // Add event listeners
            const mainRemoveBtn = document.getElementById('main-discount-remove-btn');
            const limitedRemoveBtn = document.getElementById('limited-discount-remove-btn');
            const applyButton = document.getElementById('pre-checkout-apply-discount-btn');
            const discountInput = document.getElementById('pre-checkout-discount-input');
            
            if (mainRemoveBtn) {
                mainRemoveBtn.addEventListener('click', handleDiscountRemoval);
            }
            if (limitedRemoveBtn) {
                limitedRemoveBtn.addEventListener('click', handleDiscountRemoval);
            }
            if (applyButton) {
                applyButton.addEventListener('click', handleDiscountApplication);
            }
            if (discountInput) {
                // Allow applying discount with Enter key
                discountInput.addEventListener('keypress', function(event) {
                    if (event.key === 'Enter') {
                        handleDiscountApplication();
                    }
                });
            }
            
            console.log('✅ Discount management initialized');
        }

        // Function to automatically apply WELCOME code if no discounts exist
        async function autoApplyWelcomeCode() {
            console.log('🎁 Checking for automatic WELCOME code application...');
            
            // Check if any discounts are already applied
            const appliedDiscounts = getAppliedDiscounts();
            const hasExistingDiscounts = Object.keys(appliedDiscounts).length > 0;
            
            if (!hasExistingDiscounts) {
                console.log('🎁 No existing discounts found, applying WELCOME code...');
                
                try {
                    const result = await globalAddDiscount(
                        'WELCOME',
                        null, // no button element
                        'Checking...',
                        'Applied',
                        'Invalid',
                        'Already Applied'
                    );
                    
                    if (result.success) {
                        console.log('✅ WELCOME code applied automatically');
                        // Update display
                        displayAppliedDiscounts();
                        updatePrices();
                    } else {
                        console.log('ℹ️ WELCOME code could not be applied:', result.message);
                    }
                } catch (error) {
                    console.error('❌ Error auto-applying WELCOME code:', error);
                }
            } else {
                console.log('ℹ️ Existing discounts found, skipping WELCOME auto-application');
            }
        }
        
        setupPreCheckoutCartWatcher();
        setupDiscountManagement();
        
        // Auto-apply WELCOME code after everything is set up
        setTimeout(() => {
            autoApplyWelcomeCode();
        }, 500);
    }




    doEverything();

});

// Global function to remove a supplement from cart




// Example usage:
// formatWithCurrency(window.Shopify && Shopify.currency ? Shopify.currency : null, '12.34');
